// ==================== FILE: src/config/tenantConfig.js ====================
// Centralized Tenant ID Configuration
// ------------------------------------
// This is the SINGLE SOURCE OF TRUTH for tenant ID across the entire app.
//
// HOW IT WORKS:
// 1. brandingService.fetchInitData() calls the /ordering/init API (or uses SAMPLE_INIT_RESPONSE)
// 2. The tenant ID from the response is stored in localStorage/sessionStorage via setTenantId()
// 3. getTenantId() reads from storage
//
// USAGE:
//   import { getTenantId } from '../config/tenantConfig';
//   const tenantId = getTenantId();
//
// DO NOT use process.env.REACT_APP_TENANT_ID directly in components!
// =========================================================================

const STORAGE_KEY = 'resto_tenant_id';

/**
 * Get the current tenant ID.
 * Reads from localStorage/sessionStorage (set by brandingService after init API call).
 *
 * @returns {string|null} The tenant ID or null if not yet initialized
 */
export function getTenantId() {
    return (
        localStorage.getItem(STORAGE_KEY) ||
        sessionStorage.getItem(STORAGE_KEY)
    );
}

/**
 * Store the tenant ID (called by brandingService after init response).
 * @param {string|number} tenantId
 */
export function setTenantId(tenantId) {
    if (!tenantId) return;

    const id = String(tenantId);
    localStorage.setItem(STORAGE_KEY, id);
    sessionStorage.setItem(STORAGE_KEY, id);
    console.log('🆔 Tenant ID saved centrally:', id);
}

export default getTenantId;
